import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  AsyncTaskInfo,
  AsyncTaskSchedulerInfo,
  AsyncTaskStructure,
  AsyncTaskType,
} from '@internal/backstage-plugin-devops-async-tasks-common';
import { ScanStatusResponse } from '@internal/backstage-plugin-catalog-devops-common';

export interface AsyncTasksApi {
  startAsyncTask: (
    taskType: AsyncTaskType,
    params: Record<string, any>,
    entityId?: string,
  ) => Promise<number>;
  getActiveTasks: (
    entityId: string,
    taskType: AsyncTaskType,
  ) => Promise<{
    tasks: AsyncTaskInfo[];
    scanStatus: ScanStatusResponse | undefined;
  }>;
  getTaskInfo: (taskId: number) => Promise<{
    task: AsyncTaskInfo;
    scanStatus: ScanStatusResponse | undefined;
  }>;
  getTaskStructure: (taskType: AsyncTaskType) => Promise<AsyncTaskStructure>;
  getTaskStructures: () => Promise<AsyncTaskStructure[]>;
  getSchedulersInfo: () => Promise<AsyncTaskSchedulerInfo[]>;
}

export const asyncTasksApiRef = createApiRef<AsyncTasksApi>().with({
  id: 'api-service',
  pluginId: 'devops-async-tasks',
});
